import classNames from "classnames";
import { IconTrash, IconTime, IconPDF, IconHTML, IconAudioWave, IconAssessment ,IconTEXTEDITOR, IconPPT, IconEmbedded, IconScorm} from "Icons";
import React from "react";
import { Card } from "react-bootstrap";
import { Button, InputField, OverlayTooltip} from "components";
import css from "./card-single.module.scss";
import * as util from "services/util";
import styled from "styled-components";
import { rgba } from "polished";

const StyledCardWrapper = styled.div`
&& {
  .${css.current} {
    background: linear-gradient(180deg, ${({ theme }) => rgba(theme.color4, 0.3)} 0%, #fff 100%);
  }
}
`;

const StyledCardBody = styled.div`
  && {
    .${css.img_placeholder} {
      background: linear-gradient(
        135deg,
        ${({ theme }) => theme.color3} 2%,
        ${({ theme }) => theme.color4} 84%
      );

      > .${css.placeholder_text} {
        color: ${({ theme }) => theme.button.primary.text};
      }
    }
  }
`;

export default function CardSingle(props) {
  
  // const mkDate = (time) => {
  //   const timeStamp = new Date(time).getTime();
  //   const toDate = new Date(timeStamp).getDate();
  //   const toMonth = new Date(timeStamp).getMonth() + 1;
  //   const toYear = new Date(timeStamp).getFullYear();
  //   const originalDate = toDate + "/" + toMonth + "/" + toYear;
  //   return originalDate;
  // };

  // const maxPercent = Math.round(
  //   (100 * props.maxViewedPos) / props.contentLength
  // );

  const contentLengthString = (format, len) =>
    format === "video"
      ? util.toHHMMSS(len)
      : format === "pdf"
      ? len //`${len} page${len < 1 || 1 < len ? 's' : ''}` :
      : "";

  const contentLengthStr = contentLengthString(
    props.format,
    props.content?.length
  );
  const options = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    props.onDeleteEntity(e, props.type,props);
  };

  const handleSequenceChange = (e) => {
    e.stopPropagation()
    props.onSequences(e.target.value, props.id, props.cardIndex, props.parentId)
  }
  const disabled = props.type!=="test" &&
   (props.modifiable === 0 && props.createdId.toString() !== props.createrId ||
  props.disabledMode)
// const  tip = props.modifiable === 0 && props.createdId && props.createdId.toString() !== props.ModuleCreaterId ?
// "This module is not modifiable" : "click here to see the details"
  return (
    <StyledCardWrapper>
       
      {/* <OverlayTooltip placement="top"  tip={tip}>  */}
    <Card
    // pointerOnHover={true}
      className={classNames(
        css.card,
        props.isCompleted && css.completed,
        props.isCurrent && css.current,
        props.modifiable === 0 && props.createdId.toString() !== props.createrId && css.card_inactive ,
        props.subscriptionPreview ? css.card_subscribe : ""
      )}
   
      onClick=
      {(props.modifiable === 1 && props.createdId.toString() !== props.createrId ? props.onClick  :  
        props.modifiable === 0 && props.createdId.toString() === props.createrId ? props.onClick  :  
        props.modifiable === 1 && props.createdId.toString() === props.createrId ? props.onClick  :
        props.modifiable === 0 && props.createdId.toString() !== props.createrId ? "" : props.chapterProgress && props.onSelectEntity)}
    >
      {
      !props.chapterProgress &&
      (props.format && props.type === "module"? (
        <div className={css.time}>
          { props.type === "module" && props.format === "video" ? (
            <IconTime width="14" height="14" />
          )  : props.format === "audio" ? (
            <IconAudioWave width="14" height="14" />
          )
           : props.format === "pdf" ? (
            <IconPDF width="14" height="14" />
          ) : props.format === "html" ? (
            <IconHTML width="14" height="14" />
            ) : props.format === "HTMLEditor" ? (
              <IconTEXTEDITOR width="14" height="14" />
          ) : props.format === "PPTEditor" ? (
            <IconPPT width="14" height="14" />
          ): null}
          {contentLengthStr}
        </div>
      ) :<div className={css.time}> <IconAssessment width="14" height="14"/> </div>)}

{
 props.chapterProgress && (
  props.type === "M" && props.is_audio === 1 ? (
    <div className={css.time}>
      <IconAudioWave width="14" height="14" />
    </div>
  ) : props.type === "M" && props.is_html_only === 1 ? (
    <div className={css.time}>
      <IconTEXTEDITOR width="14" height="14" />
    </div>
  ) : props.type === "M" && props.isUrl === 0 && props.isText === 0 && props.is_ppt === 0 ? (
    <div className={css.time}>
      <IconTime width="14" height="14" />
    </div>
  ) : props.type === "M" && props.isText === 1 && props.is_html_only === 0 ? (
    <div className={css.time}>
      <IconPDF width="14" height="14" />
    </div>
  ) : props.type === "M" && props.isText === 0 && props.isUrl === 1 && props.is_html_only === 0 && props.is_ppt === 0 ? (
    <div className={css.time}>
      <IconHTML width="14" height="14" />
    </div>
  ) : props.type === "M" && props.is_ppt === 1 && props.is_html_only === 0 ? (
    <div className={css.time}>
      <IconPPT width="14" height="14" />
    </div>
  ) : (
    <div className={css.time}>
      <IconAssessment width="14" height="14" />
    </div>
  )
)}
    
{
  !props.chapterProgress && (

<div className={css.delete}>
          {
            <Button
              onClick={handleDeleteClick}
              iconOnly
              variant="white"
              size="sm"
              pill
              className="px-2"
              disabled= {disabled}
            >
              <IconTrash />
            </Button>
          }
        </div>
  )}
    <br></br>
    {!props.chapterProgress && (

    <div>
       <span className="module-seq-c-build">
       <OverlayTooltip placement="top"  tip="sequence">
       <InputField
        // id={items.itemName}
        type="number"
        className="c-build-seq"
        value={props.sequence}
        min="1"
        label="Sequence"
        onChange={handleSequenceChange} 
        onClick ={(e) => e.stopPropagation()}
        />
    </OverlayTooltip>
        </span>
        </div>
    )}
 
      {/* {props.nonAcademic && (
        <div className={css.non_academic}>
            Non Academic
        </div>
      )} */}
      <StyledCardBody className={css.body}>
        <div className={css.image}>
          {/* {props.subscriptionPreview && (
            <div className={css.img_placeholder}>
              <div className={css.placeholder_text}>
                <IconLock width="23" height="23" />
              </div>
            </div>
          )} */}
          {props.contentImage && !props.subscriptionPreview && (
            <img src={props.contentImage} alt="" />
          )}
            {
       
      }
          {!props.contentImage && !props.subscriptionPreview && (
            <div className={css.img_placeholder}>
              <div className={css.placeholder_text}>
                {props.itemName && props.itemName.trim().charAt(0)}
              </div>
            </div>
          )}
          {/* {props.isCompleted && <IconCircleCheckGreen width="16" height="16" />} */}
        </div>
        
        <div className={css.content}>
         
          <div className={`${css.title} text-color3`}>
            {props.itemName && props.itemName.length > 20 ? (
              <span>{props.itemName.slice(0, 20) + "..."}</span>
            ) : (
              <span>{props.itemName}</span>
            )}
           
          </div>
          
          { props.type === "module"  || props.type === "M" ? (
            <div className={`${css.credit} text-primary`}>
              Credits: {props.moduleCredits}
            </div>
          ): ""}
          
          {/* {!props.subscriptionPreview && (
            <div className={css.assigned}>
              ASSIGNED:{" "}
              {props.assignmentDate.toLocaleDateString("en-GB", options)}
            </div>
          )} */}
        </div>
      </StyledCardBody>
    </Card>
    {/* </OverlayTooltip> */}
    </StyledCardWrapper>
  );
}

// CardSingle.propTypes = {
//   isCompleted: PropTypes.bool,
//   isCurrent: PropTypes.bool,
//   onClick: PropTypes.func,
//   progress: PropTypes.number,
// };

// CardSingle.defaultProps = {
//   isCompleted: false,
//   isCurrent: false,
//   progress: 0,
//   onClick: () => {},
// };
